
<div class="modal-content">
  <div class="modal-header">
    <label class="modal-title text-text-bold-900" id="myModalLabel33"><b>Add/Update KeywordType</b></label>
    <button type="button" class="close" aria-label="Close" (click)="close()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <form [formGroup]="definitionForm">
    <div class="modal-body">
  

      <div class="form-group">
        <label>Name</label>

        <input type="text" formControlName="name" class="form-control">
      </div>
   
 
      <div class="form-group">
        <label>Short Name</label>

        <input type="text" formControlName="shortName" class="form-control">
      </div>
      
      <div class="form-group">
        <label>Code</label>

        <input type="text" formControlName="code" class="form-control">
      </div>
     

    </div>

  


    <div class="modal-footer">
      <button type="reset" class="btn grey btn-outline-secondary btn-lg"
        (click)="close()">Close</button>
      <button type="button" class="btn btn-primary btn-lg" (click)="save()" [disabled]="submitted">
        <i class="fa fa-refresh fa-spin" *ngIf="submitted"></i>
        Save</button>
    </div>
  </form>
</div>

